import React, { useState, useEffect } from 'react';
import { Form, Input, Button } from 'antd';


interface FormItemProps {
  form: any;
  url: string;
}

const NotionUrlFormItem = ({form, url}: FormItemProps): React.ReactElement => {
  /* ======================================================
   * variables
   * ====================================================== */
  const [linkUrl, setLinkUrl] = useState<string>(url);
  /* ======================================================
  * hooks
  * ====================================================== */

  /* ======================================================
   * effects
   * ====================================================== */
  useEffect(() => {
    setLinkUrl(url);
  }, [url]);
  /* ======================================================
   * render items
   * ====================================================== */
  return (
    <>
      <Form.Item name="notion_url" style={{ width:'calc(100% - 60px - 10px)', display: 'inline-block', marginRight: '5px' }}>
          <Input type="text" placeholder='강의요청서를 입력하세요' onChange={(e) => setLinkUrl(e.target.value)}/>                    
      </Form.Item>   
      <Button style={{ width:'60px', display: 'inline-block', marginRight: '5px' }} onClick={()=>window.open(linkUrl, "notion", "noopener, noreferrer")} disabled={!linkUrl}>보기</Button>  
    </>
  );
};

export default NotionUrlFormItem;
